import { ContentUnsubscribe } from '@/domain/usecases/content/content-unsubscribe'
import { queryClient } from '@/infra/http'
import { importRemote } from '@/main/routes/helpers/loaders'

/**
 * Loads content unsubscribe data
 * Fetches unsubscribe information for an enrollment
 */
export async function loadContentUnsubscribe(id: string) {
  const remote = await importRemote<ContentUnsubscribe>('makeRemoteContentUnsubscribe', queryClient)
  return remote.getUnsubscribeData(id)
}
